import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import closeoff from "../../../assets/Asssignment/close.png";
import tata from "../../../assets/Vehicles/tata.png";
import renewal from "../../../assets/svg/Renewal/renewal (1).svg";
import { getRenewalReminderDetailsApi } from "../renewal-api.js";
import calender from "../../../assets/svg/vendor/calender.svg";
import vendor from "../../../assets/svg/vendor.svg";
import clock from "../../../assets/svg/Renewal/clock.svg";
import attachment from "../../../assets/png/attachment.png";
import download from "../../../assets/svg/download.svg";

export const ViewUpcomingRenewal = ({ id, show, handleClose }) => {
  useEffect(() => {
    if (id != null && id !== undefined) {
      getRenewalDetails(id);
    }
  }, [id]);

  const [renewalDetail, setRenewalDetail] = useState({});

  const getRenewalDetails = async (id) => {
    try {
      const response = await getRenewalReminderDetailsApi(id);

      if (response.data.success === true) {
        setRenewalDetail(response.data.reminder ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };
  const details = [
    {
      label: "Due date",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="vendor" />
          <span>{renewalDetail.due_date ?? ""}</span>
        </div>
      ),
    },
    {
      label: "Vendor",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={vendor} alt="vendor" />
          <span>{renewalDetail.vendor ?? ""}</span>
        </div>
      ),
    },
    {
      label: "Renewal period",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={clock} alt="vendor" />
          <span>
            {renewalDetail.renewal_period ?? "0"} {renewalDetail.period_type ?? ""}
          </span>
        </div>
      ),
    },

    {
      label: "Description",
      value: renewalDetail.description ?? "",
    },
  ];
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end" style={{ width: "520px" }}>
      <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center p-0">
        <Offcanvas.Title className="bg-grey w-100 p-3 d-flex flex-wrap justify-content-between align-items-center justify-content-xl-between">
          <div>
            <div className="d-flex gap-3">
              <img src={renewal} alt="renewal" className="p-3 bg-white rounded-4" />
              <div className="d-flex flex-column">
                <p className="m-0 fs-20 fw-800 mb-1 ">{renewalDetail.renewal_name ?? ""}</p>
                <div className="d-flex align-items-center">
                  <span className="me-2 text-muted-grey fs-13 fw-600">ID : {renewalDetail.lic_no ?? ""}</span>
                  <span className="me-2" style={{ color: "#D9D9D9" }}>
                    •
                  </span>
                  <span className="border-0 text-dark-purple py-1 px-4 rounded-pill fs-13 fw-400 d-inline-flex align-items-center gap-2" style={{ backgroundColor: "#C0FFDA" }}>
                    <span
                      style={{
                        backgroundColor: "#2C8C53",
                        height: "8px",
                        width: "8px",
                        borderRadius: "3px",
                      }}
                    ></span>
                    {renewalDetail.status ?? ""}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex gap-3">
            <img src={closeoff} alt="closeoff" className="cursor-pointer" onClick={handleClose} />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="p-3 rounded-4 my-3" style={{ backgroundColor: "#F8F8F8" }}>
          <div className="d-flex gap-3">
            <div className="rounded-4" style={{ backgroundColor: "#E8E8E8" }}>
              <img src={tata} alt="tata" />
            </div>
            <div>
              <p className="m-0 fs-20 fw-semibold mb-1" style={{ color: "#21272C" }}>
                {renewalDetail.lic_no ?? ""}
              </p>
              <div className="d-flex align-items-center">
                <span className="me-2 fs-14 fw-400" style={{ color: "#A2A7AE" }}>
                  {renewalDetail.vehicle_name ?? ""}
                </span>
                <span className="me-2">•</span>
                {renewalDetail.year_of_make && (
                  <span style={{ background: "#F0DBFF", color: "#A2A7AE" }} className="border-0 py-1 px-4 rounded-pill  fs-12">
                    {renewalDetail.year_of_make ?? ""}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="bg-white rounded-4 mt-3 p-2 d-flex justify-content-start align-items-center">
            <span className="fs-13 fw-400" style={{ color: "#8790A1" }}>
              Vehicle identification number (VIN) :
            </span>
            <span className="fs-14 fw-500" style={{ color: "#172B4D" }}>
              &nbsp;{renewalDetail.vin ?? ""}
            </span>
          </div>
        </div>

        <div>
          <p className="m-0 fs-15 fw-600" style={{ color: "#212129" }}>
            Other details
          </p>
          <div className="table-container rounded-4 overflow-hidden my-3">
            <table className="table table-borderless mb-0">
              <tbody>
                {details.map((item, index) => (
                  <tr key={index}>
                    <td
                      className="fs-13 fw-500 w-25"
                      style={{
                        color: "#49494B",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.label}
                    </td>
                    <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                      {item.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="fs-16 fw-600">Attachments - {renewalDetail?.images?.length}</p>
          {renewalDetail?.images?.length > 0 && (
            <div className="row gap-2">
              {renewalDetail?.images?.map((item, attachIndex) => (
                <div style={{ width: "312px" }}>
                  <div className="d-flex align-items-center bg-white rounded-4 p-2" style={{ border: "1px solid #EBEBEB" }}>
                    <img src={attachment} alt="attachment" style={{ width: "24px", height: "24px" }} />
                    <div style={{ width: "calc(100% - 32px)", marginLeft: "8px" }}>
                      <div
                        className="fs-13 fw-500"
                        style={{
                          width: "100%",
                          color: "#172B4D",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name}
                      </div>
                      <div className="fs-12 fw-400" style={{ color: "#8790A1" }}>
                        {item.size}
                      </div>
                    </div>
                    {item.url && (
                      <div
                        onClick={() => {
                          downloadFile(item.url, item.url.split("/").pop());
                        }}
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "100px",
                        }}
                      >
                        <img
                          src={download}
                          alt="download"
                          style={{
                            width: "12.8px",
                            height: "12px",
                            top: "10px",
                            left: "9.6px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
